import { render, staticRenderFns } from "./CampaignModal.vue?vue&type=template&id=5177cba9&scoped=true&"
import script from "./CampaignModal.vue?vue&type=script&lang=ts&"
export * from "./CampaignModal.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignModal.vue?vue&type=style&index=0&id=5177cba9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5177cba9",
  null
  
)

export default component.exports